import { render } from "./OrderAttachments.vue?vue&type=template&id=53044e78&scoped=true"
import script from "./OrderAttachments.vue?vue&type=script&lang=js"
export * from "./OrderAttachments.vue?vue&type=script&lang=js"

import "./OrderAttachments.vue?vue&type=style&index=0&id=53044e78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53044e78"]])

export default __exports__